// Mirrors CAMPAIGN_TRIGGERS in parceldaily-api constants/campaign.ts
export const CAMPAIGN_TRIGGERS = {
  TOPUP: "TOPUP",
};

export const CAMPAIGN_TRIGGER_LABELS = {
  [CAMPAIGN_TRIGGERS.TOPUP]: "Online Top-up",
};
